import { resolveI18n } from "../../../commons/services/Translation"

export const TableCellsWidth = (i18n) => {
  return [
    resolveI18n({ i18n, ko: "5%", en: "5%", vi: "8%" }),
    resolveI18n({ i18n, ko: "15%", en: "15%", vi: "12%" }),
    resolveI18n({ i18n, ko: "20%", en: "20%", vi: "15%" }),
    resolveI18n({ i18n, ko: "15%", en: "15%", vi: "15%" }),
    resolveI18n({ i18n, ko: "12%", en: "12%", vi: "12%" }),
    resolveI18n({ i18n, ko: "13%", en: "13%", vi: "13%" }),
    resolveI18n({ i18n, ko: "10%", en: "10%", vi: "15%" }),
  ]
}